/* eslint-disable @typescript-eslint/no-explicit-any */
interface StringMap {
	[k: string]: string;
}

export interface GetOptions {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- SS 2024-11-25 Disabled to allow enabling lint rules wtihout changing existing behaviour.
	queryData: {};
	headers: StringMap;
}

export interface BodyRequestOptions {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- SS 2024-11-25 Disabled to allow enabling lint rules wtihout changing existing behaviour.
	data: {};
	isFormData: boolean;
	headers: StringMap;
}

export interface IClient {
	_delete(path: string, data?: object): Promise<any>;
	get(path: string, queryData?: object): Promise<any>;
	getFingerprintHeaders(): Promise<{ [h: string]: string }>;
	getPathWithQueryString(path: string, query?: object): string;
	getWithOptions(path: string, options: Partial<GetOptions>): Promise<any>;
	post(path: string, data?: object, isFormData?: boolean): Promise<any>;
	postWithOptions(path: string, options?: Partial<BodyRequestOptions>): Promise<any>;
	put(path: string, data?: object, isFormData?: boolean): Promise<any>;
}

export class Client {
	static innerClient: IClient;

	static async _delete(path: string, data?: object) {
		return this.innerClient._delete(path, data);
	}

	static async get(path: string, queryData: object = {}) {
		return this.innerClient.get(path, queryData);
	}

	static async getFingerprintHeaders() {
		return this.innerClient.getFingerprintHeaders();
	}

	static getPathWithQueryString(path: string, query?: object) {
		return this.innerClient.getPathWithQueryString(path, query);
	}

	static async getWithOptions(path: string, options: Partial<GetOptions>) {
		return this.innerClient.getWithOptions(path, options);
	}

	static async post(path: string, data?: object, isFormData?: boolean) {
		return this.innerClient.post(path, data, isFormData);
	}

	static async postWithOptions(path: string, options?: Partial<BodyRequestOptions>) {
		return this.innerClient.postWithOptions(path, options);
	}

	static async put(path: string, data?: object, isFormData?: boolean) {
		return this.innerClient.put(path, data, isFormData);
	}
}
